import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import urls, { codeUrl } from '@/constants/urls';
import {
  columnCreatedOn,
  columnAssignee,
  columnRequester,
  columnDataset,
  columnWorkflowName,
  columnTools,
  columnDatasetLink,
  columnRequest,
  columnRequestLink,
  hasColumn,
} from '@/constants/fields';
import NameDescriptionRow from '@/components/table/NameDescriptionRow';
import PastDateCell from '@/components/table/PastDateCell';
import SimpleCell from '@/components/table/SimpleCell';
import { hasMinimumLength } from '@/utils/resultsHelper';
import DatasetCell from '@/datasets/components/DatasetCell';
import { taskRequestAssignedToMe, taskRequestWarning } from '../state/state';
import RequestCell from '../../components/RequestCell';
import RequestedByCell from '../../components/RequestedByCell';
import Events from '../hooks/events';
import TaskToolsMenu from './TaskToolsMenu';
import TaskAssigneeCell from './TaskAssigneeCell';

const TaskRow = ({
  canEdit,
  category,
  className,
  columns,
  email,
  task,
  upward,
}) => {
  const show = Events.useShowRequestTask();
  const hasRequester = hasMinimumLength(task.request.requester.name);
  const error = taskRequestWarning(task);

  return (
    <NameDescriptionRow
      asHref
      className={clsx('aridhia-task-row', className)}
      columns={columns}
      entity="task"
      error={error}
      href={codeUrl(urls.TASKS, task.code)}
      icon={error ? 'ban' : undefined}
      name={task.name}
      onClick={() => show({ task })}
      positive={error ? undefined : taskRequestAssignedToMe(email, task)}
    >
      {hasColumn(columns, columnAssignee) && (<TaskAssigneeCell canEdit={canEdit} category={category} task={task} />)}
      {hasColumn(columns, columnCreatedOn) && (<PastDateCell content={task.createTime} />)}
      {hasColumn(columns, columnRequest) && (<SimpleCell content={task.request.name} />)}
      {hasColumn(columns, columnRequestLink) && (<RequestCell request={task.request} />)}
      {hasColumn(columns, columnDataset) && (<SimpleCell content={task.request.datasets[0].catalogue?.title} />)}
      {hasColumn(columns, columnDatasetLink) && (<DatasetCell dataset={task.request.datasets[0]} />)}
      {hasColumn(columns, columnRequester) && hasRequester && (<RequestedByCell user={task.request.requester} />)}
      {hasColumn(columns, columnRequester) && !hasRequester && (<Table.Cell />)}
      {hasColumn(columns, columnWorkflowName) && (<SimpleCell content={task.workflow.name} />)}
      {hasColumn(columns, columnTools) && (
        <Table.Cell collapsing>
          <TaskToolsMenu category={category} upward={upward} task={task} />
        </Table.Cell>
      )}
    </NameDescriptionRow>
  );
};

export default TaskRow;
